var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 12.1875C2.5 11.7731 2.66462 11.3757 2.95765 11.0826C3.25067 10.7896 3.6481 10.625 4.0625 10.625H12.5",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 1.25H12.5V13.75H4.0625C3.6481 13.75 3.25067 13.5854 2.95765 13.2924C2.66462 12.9993 2.5 12.6019 2.5 12.1875V2.8125C2.5 2.3981 2.66462 2.00067 2.95765 1.70765C3.25067 1.41462 3.6481 1.25 4.0625 1.25Z",
    strokeWidth: 1.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a101a5642197295290162f88da6bda3f.svg";
export { ForwardRef as ReactComponent };